module.exports = __webpack_public_path__ + "static/revtel-icon-1dc6a3568cff3d749c4cf36c7eace145.png";